import React from 'react';
import { Box, Typography } from '@mui/material';
import { resolveSlotValues, getDTWidgetSlots } from '../../registry/dtWidgetTypes';
import { useDTDemoMap } from '../../hooks/useDTDemoTick';
import { hasLiveSlotValue } from '../../utils/dtDemoFallback';
import { dtWidgetFilledColumnSx } from '../../styles/dtWidgetStyleTokens';

const DEFAULT_SLOTS = getDTWidgetSlots('dt-voltage-table');

function DTVoltageTable({ widget, data, theme }) {
  const isDark = theme === 'dark';
  const tagprops = widget?.props?.extended?.tagprops || [];
  const liveData = Array.isArray(data) ? data : [];
  const slotValues = resolveSlotValues(tagprops, liveData);
  const demoMap = useDTDemoMap('dt-voltage-table');

  const rows = DEFAULT_SLOTS.map((slot) => {
    const resolved = slotValues[slot.key];
    const liveOk = hasLiveSlotValue(resolved);
    const demoVal = demoMap[slot.key];
    return {
      label: resolved?.alias || slot.label,
      value: liveOk ? resolved.value : demoVal ?? '—',
      unit: resolved?.unit || slot.unit,
    };
  });

  return (
    <Box sx={dtWidgetFilledColumnSx}>
      <Typography variant="subtitle2" sx={{ color: isDark ? '#fff' : '#000', fontWeight: 700, mb: 0.5, borderBottom: '1px solid #B0B0B0', flexShrink: 0 }}>
        Voltage (V)
      </Typography>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly' }}>
        {rows.map((row, i) => (
          <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: '1 1 0', minHeight: 0 }}>
            <Typography variant="body2" sx={{ color: isDark ? '#aaa' : '#555', pr: 1 }}>{row.label}</Typography>
            <Typography variant="body2" sx={{ color: isDark ? '#fff' : '#000', fontWeight: 600 }}>
              {row.value !== null && row.value !== '—' ? `${row.value}` : '—'}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default React.memo(DTVoltageTable);
